import React from 'react';
import useSavedSearch from '~/hooks/useSavedSearch';
import FavoriteIcon from '~/public/static/svg/FavoriteIcon';

interface Props {}

const SavedSearchCta: React.FC<Props> = () => {
  const { savedSearch, toggleSavedSearch, isLoading } = useSavedSearch();

  return (
    <div>
      <button
        className="flex items-center gap-2 text-sm font-semibold text-green-500"
        id="saved-search-cta"
        type="button"
        onClick={toggleSavedSearch}
      >
        <FavoriteIcon
          fill="currentColor"
          className="h-4 w-4"
          active={savedSearch != null}
        />
        <span>Save this search</span>
      </button>
    </div>
  );
};

export default SavedSearchCta;
